import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ShareService } from '@nttp/common-service/share-service';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationStep2Guard implements CanActivate {
  constructor(
    private router: Router,
    private shareService: ShareService
  ) { }
  canActivate() {
    const getRole = new Promise(resolve => {
      this.shareService.accountType$.subscribe(data => {
        if (data.isStep2Completed) {
          this.router.navigate(['client/dashboard']);
          resolve(false);
        }
        resolve(true);
      });
    });
    return from(getRole) as Observable<boolean>;
  }
}
